import { Box, Flex, Image, Progress, Text } from '@chakra-ui/react';
import { useCapaDoPilar } from '../../hooks/useCapaDoPilar';

function PillarSelectorCard({ pillar, isSelected, onSelect }) {
  const { id_pillar, name_pillar, img_pillar, answeredQuestions, totalQuestions } = pillar;
  const imageURL = useCapaDoPilar(img_pillar);
  const progressValue = totalQuestions ? (answeredQuestions / totalQuestions) * 100 : 0;

  return (
    <Flex
      as='button'
      type='button'
      onClick={() => onSelect(id_pillar)}
      bg='white'
      minW='220px'
      maxW='220px'
      h='100px'
      borderRadius='12px'
      border='2px solid'
      borderColor={isSelected ? '#598F3C' : 'transparent'}
      boxShadow={isSelected ? 'none' : '0 0 0 1px #E5E5E5'}
      overflow='hidden'
      textAlign='left'
      transition='border-color 0.15s'
    >
      <Flex w='72px' h='100px' flexShrink={0} overflow='hidden'>
        {imageURL ? (
          <Image objectFit='cover' src={imageURL} alt={name_pillar} w='100%' h='100%' />
        ) : (
          <Box bg='rgba(0, 0, 0, 0.15)' w='100%' h='100%' />
        )}
      </Flex>

      <Flex direction='column' justify='center' px='12px' flex='1' minW={0}>
        <Text
          fontSize='sm'
          fontWeight={600}
          color={isSelected ? '#0073BB' : '#1A202C'}
          noOfLines={2}
          mb='8px'
        >
          {name_pillar}
        </Text>

        <Progress
          value={progressValue}
          colorScheme='green'
          h='6px'
          bg='#D4D4D4'
          borderRadius='21px'
          mb='4px'
        />

        <Text fontSize='xs' color='#5C6066'>
          {answeredQuestions}/{totalQuestions}
        </Text>
      </Flex>
    </Flex>
  );
}

export default function PillarSelectorRow({ pillars, selectedPillar, onSelect }) {
  if (!pillars?.length) return null;

  return (
    <Flex gap='12px' overflowX='auto' pb='4px'>
      {pillars.map((pillar) => (
        <PillarSelectorCard
          key={pillar.id_pillar}
          pillar={pillar}
          isSelected={pillar.id_pillar === selectedPillar}
          onSelect={onSelect}
        />
      ))}
    </Flex>
  );
}
